import React from 'react'
import {useSelector} from 'react-redux'
import {useVioTag} from 'hooks/useVioTag'
import {getCurrencyCode} from 'modules/meta/selectors'
import {getShowTotalPrices} from 'modules/sapiSearch/selectors'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'
import {VioDealTag} from '@vio/shared/src/privateDeal/VioDealTag'

interface Props {
  anchorPrice?: number
  anchorPriceTotal?: number
  offer: SearchOffer
}

export const VioDealTagContainer: React.FC<Props> = ({
  anchorPrice,
  anchorPriceTotal,
  offer
}) => {
  const currencyCode = useSelector(getCurrencyCode)
  const showTotalPrices = useSelector(getShowTotalPrices)

  const {brandName} = useBrand()
  const {
    isVioTagVisible,
    savingType,
    savingPrice,
    savingPercentage,
    tagMessage
  } = useVioTag({
    price: showTotalPrices ? offer.totalRate : offer.nightlyRate,
    anchorPrice: showTotalPrices ? anchorPriceTotal : anchorPrice,
    currencyCode,
    offerTags: offer?.tags
  })

  if (!isVioTagVisible || !tagMessage) return null
  return (
    <VioDealTag
      message={{...tagMessage, values: {brandName}}}
      savingPercentage={savingPercentage}
      savingPrice={savingPrice}
      currencyCode={currencyCode}
      savingType={savingType}
    />
  )
}
